module.exports = __webpack_public_path__ + "media/Tools.bf68f75bbe07361b09b5f36aa5186583.svg";